import axios from "axios";
import { createSlice } from "@reduxjs/toolkit";
import { startLoading, endLoading } from "@/store/loading/LoadingSlice";

const GET_STATS_URL = `${process.env.NEXT_PUBLIC_APP_URL}/api/portfolio/get-stats`;

const initialState = {
  stats: null,
  hasFetched: false,
};

export const PortfolioDataSlice = createSlice({
  name: "portfolio",
  initialState,
  reducers: {
    getStats: (state, action) => {
      state.stats = action.payload;
      state.hasFetched = true;
    },
    prepare: (id, title, color) => {
      return {
        payload: {
          id,
          title,
          color,
          datef: new Date().toDateString(),
          deleted: false,
        },
      };
    },
  },
});

export const { getStats } = PortfolioDataSlice.actions;

export const fetchPortfolioStats = () => async (dispatch, getState) => {
  const { hasFetched } = getState().portfolio;
  if (hasFetched) return;

  dispatch(
    startLoading({
      requestId: "portfolio-stats",
      category: "silent",
    })
  );

  try {
    const response = await axios.get(`${GET_STATS_URL}`, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });

    const data = response.data;

    dispatch(getStats(data));
    return Promise.resolve(data);
  } catch (error) {
    console.error("Error get stats:", error);
    return Promise.reject(error);
  } finally {
    dispatch(
      endLoading({
        requestId: "portfolio-stats",
        category: "silent",
      })
    );
  }
};

export default PortfolioDataSlice.reducer;
